import ChoiceField from "./ChoiceField";

class ChoicesField extends ChoiceField {
    constructor(name) {
        super(name);
        this._type = "choices";
    }
}

export default ChoicesField;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Field/ChoicesField.js
 **/